import { useForm } from "@inertiajs/react"
import gravatarUrl from "gravatar-url"
import moment from "moment"
import { useState } from "react"
import translate from "@/utils/translate"

export default function BlogComment({ blog, commnets }) {
    const [isReplay, setIsReplay] = useState(false)
    const [replayAuthName, setReplayAuthName] = useState("")
    const { data, setData, post, errors, processing, reset } = useForm({
        full_name: "",
        email: "",
        website: "",
        comment: "",
        post_id: blog?.id,
        comment_parent: null
    })
    // handle comment
    const handleSubmit = (e) => {
        e.preventDefault()

        post(route("blog.comment"), {
            onSuccess: () => {
                reset("full_name", "email", "website", "comment", "comment_parent")
                setIsReplay(false)
            }
        })
    }
    return (
        <>
            {commnets?.length ? (
                <div className="comment-wrap">
                    <div className="comment-wrap-title mb-35">
                        <h5 className="title">{blog?.comment_count_string} </h5>
                    </div>
                    <div className="latest-comments mb-65">
                        <ul className="list-wrap">
                            {commnets.map((comment, index) => (
                                <li id={`comment-${comment?.id}`} key={index}>
                                    <div className="comments-box">
                                        <div className="comments-avatar">
                                            <img
                                                alt=""
                                                src={gravatarUrl(comment?.comment_author_email) ?? ""}
                                                className="avatar avatar-110 photo"
                                                height={110}
                                                width={110}
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        </div>
                                        <div className="comment-text">
                                            <div className="avatar-name mb-10">
                                                <h6 className="name">
                                                    <a href={comment?.comment_author_website ?? "#"} rel="external nofollow ugc" className="url">
                                                        {comment?.comment_author_name ?? ""}
                                                    </a>
                                                    <span
                                                        onClick={() => {
                                                            setIsReplay(true)
                                                            setReplayAuthName(comment?.comment_author_name ?? "")
                                                            setData("comment_parent", comment?.id)
                                                        }}
                                                        style={{
                                                            cursor: "pointer"
                                                        }}
                                                        className="comment-reply-link"
                                                    >
                                                        <i className="fa-light fa-reply" style={{ marginRight: '5px' }}></i>
                                                        {translate("Reply")}
                                                    </span>
                                                </h6>
                                                <span className="date">{comment?.created_at ? moment(comment.created_at).format("ll") : ""}</span>
                                            </div>
                                            <p>{comment?.comment_content ?? ""}</p>
                                        </div>
                                    </div>
                                </li>
                            ))}
                            {/* #comment-## */}
                        </ul>
                    </div>
                </div>
            ) : (
                <></>
            )}

            <h2 className="cs_font_50 cs_m0 cs_normal" id="response">
                {isReplay ? `${translate("Replay to")}: ${replayAuthName}` : translate("Leave A Reply")}
            </h2>
            {isReplay ? (
                <small
                    onClick={() => {
                        setIsReplay(false)
                        setData("comment_parent", null)
                    }}
                >
                    <span style={{ cursor: "pointer" }}>{translate("Cancel reply")}</span>
                </small>
            ) : (
                <></>
            )}
            <div className="cs_height_5 cs-height_lg_5"></div>
            <p className="cs_m0">{translate("Your email address will not be published. Required fields are marked")} *</p>
            <div className="cs_height_40 cs_height_lg_30"></div>
            <form className="row" onSubmit={handleSubmit}>
                <div className="col-lg-6">
                    <label>{translate("Full Name")}*</label>
                    <input
                        type="text"
                        className="cs_form_field"
                        value={data?.full_name ?? ""}
                        onChange={(e) => setData("full_name", e.target.value)}
                        required
                    />
                    {errors?.full_name && <span className="text-danger">{errors.full_name}</span>}
                    <div className="cs_height_20 cs_height_lg_20" />
                    <div
                        data-lastpass-icon-root="true"
                        style={{
                            position: "relative !important",
                            height: "0px !important",
                            width: "0px !important",
                            float: "left !important"
                        }}
                    />
                </div>
                <div className="col-lg-6">
                    <label>{translate("Email")}*</label>
                    <input type="email" className="cs_form_field" value={data?.email ?? ""} onChange={(e) => setData("email", e.target.value)} required />
                    {errors?.email && <span className="text-danger">{errors.email}</span>}
                    <div className="cs_height_20 cs_height_lg_20" />
                </div>
                <div className="col-lg-12">
                    <label>{translate("Website")}</label>
                    <input type="text" className="cs_form_field" value={data?.website ?? ""} onChange={(e) => setData("website", e.target.value)} />
                    {errors?.website && <span className="text-danger">{errors.website}</span>}
                    <div className="cs_height_20 cs_height_lg_20" />
                </div>
                <div className="col-lg-12">
                    <label>{translate("Write Your Comment")}*</label>
                    <textarea
                        cols={30}
                        rows={7}
                        className="cs_form_field"
                        value={data?.comment ?? ""}
                        onChange={(e) => setData("comment", e.target.value)}
                        required
                    />
                    {errors?.comment && <span className="text-danger">{errors.comment}</span>}
                    <div className="cs_height_25 cs_height_lg_25" />
                </div>
                <div className="col-lg-12">
                    <button className="cs_btn cs_style_1 cs_type_2 cs_primary_bg cs_white_color" disabled={processing}>
                        {translate("Post Comment")}
                        <span>
                            <i className="fa-light fa-arrow-right"></i>
                        </span>
                    </button>
                </div>
            </form>
        </>
    )
}